/*! bxs-vue-ui v4.0.1 */
import './index.js';
import { c as concat } from './concat.js';

var Emitter = {
  methods: {
    dispatch: function dispatch(componentName, eventName, params) {
      var parent = this.$parent || this.$root;
      var name = parent.$options.name;

      while (parent && (!name || name !== componentName)) {
        parent = parent.$parent;

        if (parent) {
          name = parent.$options.name;
        }
      }

      if (parent) {
        var _parent, _context;

        (_parent = parent).$emit.apply(_parent, concat(_context = [eventName]).call(_context, params));
      }
    }
  }
};

export { Emitter as E };
